'use client';
/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import RenderSections from '@app-kb/Common/RenderSections';
import WrapLayout from '@app-ps/Components/Layout/WrapLayout';

/* Services */
// import SamskritiContextProvider from '@app-ps/Store/samskriti-context';
import { Suspense } from 'react';
const MainUi = ({ pageData, region, lang, params }) => {
  // console.log(pageData);
  return (
    <Suspense fallback={<Skeleton />}>
      {/* <SamskritiContextProvider> */}
      <WrapLayout>
        {/* <HeadComponent
          data={pageData?._seoMetaTags || pageData?.seoFields}
          availableLocals={pageData?.availableLocales}
        >
          {' '}
        </HeadComponent> */}
        <Suspense fallback={<Skeleton />}>
          <Box as="section" className="container-article" p="0">
            <Suspense fallback={<Skeleton />}>
              {pageData?.body?.map(section => {
                return (
                  <RenderSections
                    pageData={pageData}
                    section={section}
                    region="in"
                    lang="en"
                    key={nanoid(4)}
                    // headerMenuData={headerMenuData}
                  />
                );
              })}
            </Suspense>
          </Box>
        </Suspense>
      </WrapLayout>
      {/* </SamskritiContextProvider> */}
    </Suspense>
  );
};

export default MainUi;
